import { gql } from '@apollo/client';

export const GET_MEDIA = gql`
  query media($tenantId: Int!) {
    media(tenantId: $tenantId) {
      id
      signedUrl
      fileType
      createdAt
      step {
        subject
        id
        activity {
          id
        }
      }
      comments {
        id
        body
        user {
          id
          firstName
          lastName
        }
        createdAt
      }
    }
  }
`;
